<div class="bcg p-4">
  <div class="d-flex justify-content-between custom-container">
    <nav class="custom-nav">
      <ol class="breadcrumb">
        <li *ngIf="userRole === 'CLIENT'; else showAdminDashboard"
          class="breadcrumb-item" style="cursor: pointer" [routerLink]="'/doqfy/dashboard'">
          Dashboard
        </li>
        <ng-template #showAdminDashboard>
          <li class="breadcrumb-item" style="cursor: pointer" [routerLink]="'/doqfy/admin-dashboard'">
            Dashboard
          </li>
        </ng-template>
        <li class="breadcrumb-item active" style="cursor: context-menu" aria-current="page">
          Wallet Transactions
        </li>
      </ol>
    </nav>
  </div>

  <!-- Title Card -->
  <div class="card card_outLine mt-3">
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-lg-6 col-sm-6 col-md-6">
          <h5 class="title_five">Wallet Transaction Details</h5>
          <p class="card-text text_p">View all wallet transactions</p>
        </div>
        <div class="col-lg-6 col-sm-6 col-md-6 d-flex align-items-center justify-content-end header-right">
          <div class="balance-info">
            <i class="pi pi-wallet"></i>
            <span>Total Balance</span>
            <span class="balance-amount">
              <span style="font-family: Arial; padding-right: 0.2rem">&#8377;</span>{{ currentBalance ?? 'NA' }}
            </span>
          </div>
          <div class="custom_button">
            <p-button label="Back" (click)="goBack()" styleClass="p-button-sm"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Table Card -->
  <div class="card card_outLine mt-3">
    <div class="card-body">

      <!-- Virtual Account Info + Filters Row -->
      <div class="row mx-1 align-items-center mb-2">
        <div class="col-lg-4 col-sm-12 col-md-4">
          <span class="account-info-text">
            Doqfy Virtual Account No: <strong>{{ virtualAccountNo }}</strong>
          </span>
        </div>
        <div class="col-lg-8 col-sm-12 col-md-8 d-flex align-items-center justify-content-end transaction-filters">
          <div class="tf-search">
            <app-search-input
              [(ngModel)]="searchTerm"
              (ngModelChange)="onSearch()"
              placeholder="Search by Transaction ID...">
            </app-search-input>
          </div>
          <div class="tf-date">
            <p-datepicker
              [(ngModel)]="dateRange"
              (ngModelChange)="onDateRangeChange()"
              selectionMode="range"
              [showIcon]="true"
              iconDisplay="input"
              placeholder="Date Range"
              dateFormat="dd/mm/yy"
              [showButtonBar]="true"
              appendTo="body">
            </p-datepicker>
          </div>
          <div class="tf-status">
            <app-dropdown
              class="custom-dropdown text-left"
              [options]="statusOptions"
              [(ngModel)]="statusFilter"
              (onChange)="onStatusChange()"
              placeholder="Status: All"
              optionLabel="label"
              [showClear]="false"
              [sort]="false">
            </app-dropdown>
          </div>
          <div class="tf-type">
            <app-dropdown
              class="custom-dropdown text-left"
              [options]="typeOptions"
              [(ngModel)]="typeFilter"
              (onChange)="onTypeChange()"
              placeholder="Type: All"
              optionLabel="label"
              [showClear]="false"
              [sort]="false">
            </app-dropdown>
          </div>
          <div class="custom_button">
            <p-button
              label="Export"
              icon="bx bx-export"
              (click)="exportData()"
              styleClass="p-button-sm-outline">
            </p-button>
          </div>
          <div class="custom_button">
            <app-column-chooser [table]="dataTable"></app-column-chooser>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="row m-2 mt-3">
        <app-data-table
          #dataTable
          [columnChooser]="true"
          [columns]="columns"
          [data]="transactions"
          [loading]="isTransactionsLoading"
          [totalRecords]="totalRecords"
          [rows]="itemsPerPage"
          [paginator]="true"
          [lazy]="true"
          emptyMessage="No Records Found"
          (pageChange)="onPageChange($event)">
          <ng-template appTableCell="s_no" let-row let-i="index">
            {{ (currentPage - 1) * itemsPerPage + i + 1 }}
          </ng-template>

          <ng-template appTableCell="created_at" let-row>
            {{ row.created_at | customDate }}
          </ng-template>

          <ng-template appTableCell="order_id" let-row>
            <ng-container *ngIf="row.additional_data?.order_id; else noOrderId">
              <a (click)="navigateToOrder(row)" class="order-id-link" title="View Order Details">
                {{ row.additional_data.order_id }}
              </a>
            </ng-container>
            <ng-template #noOrderId>
              <span>--</span>
            </ng-template>
          </ng-template>

          <ng-template appTableCell="utr" let-row>
            <div class="d-flex align-items-center">
              <span class="utr-text">{{ row.utr || '--' }}</span>

              <div class="copy-container ms-2" *ngIf="row.utr">
              <i class="pi pi-copy cursor-pointer"
                (click)="copyUtrToClipboard(row.utr, row)"></i>
              <span class="copy-badge" [class.show]="row.justCopied">Copied!</span>
            </div>
            </div>
          </ng-template>

          <ng-template appTableCell="purpose" let-row>
            {{
              row.transaction_sub_type === 'Recharge' ? 'Wallet Recharge' :
              row.transaction_sub_type === 'Service_Charge' ? 'Service Order Payment' :
              row.transaction_sub_type
            }}
          </ng-template>

          <ng-template appTableCell="status" let-row>
            <span class="status-badge" [ngClass]="getStatusClass(row.status)">
              {{ row.status === 'Successful' ? 'Success' : row.status }}
            </span>
          </ng-template>

          <ng-template appTableCell="transaction_type" let-row>
            <i *ngIf="row.transaction_type === 'Debit'" class="pi pi-minus mr-1"
              style="color: red; padding-right: 5px; font-size: 10px; font-weight: bold;"></i>
            <i *ngIf="row.transaction_type === 'Credit'" class="pi pi-plus mr-1"
              style="color: green; padding-right: 5px; font-size: 10px; font-weight: bold;"></i>
            {{ row.transaction_type }}
          </ng-template>

          <ng-template appTableCell="amount" let-row>
            <span style="font-family: Arial; padding-right: 0.2rem">&#8377;</span>
            <ng-container *ngIf="row?.additional_data?.order_id; else plainAmount">
              <a (click)="getAmountSummary(row)" class="order-id-link" title="View Payment Summary">
                {{ row.amount }}
              </a>
            </ng-container>
            <ng-template #plainAmount>
              <span>{{ row.amount }}</span>
            </ng-template>
          </ng-template>
        </app-data-table>
      </div>

    </div>
  </div>
</div>

<!-- View Order Modal -->
<ng-template #viewOrderData let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">View Order</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal"
      (click)="modal.dismiss('Cross click')" aria-label="Close"></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <app-view-order [viewOrderId]="viewOrderId"></app-view-order>
  </div>
</ng-template>

<!-- Payment Summary Modal -->
<ng-template #paymentSummaryModal let-modal>
  <div class="modal-header">
    <h4 class="title_five">Payment Summary</h4>
    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div *ngIf="paymentAmountData" class="summary-grid">
      <div class="summary-row">
        <span class="summary-label">Stamp Amount:</span>
        <span class="summary-value">{{ paymentAmountData.stamp_amount | currency : "INR" : "symbol" : "1.2-2" }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Stamp Convenience:</span>
        <span class="summary-value">{{ paymentAmountData.stamp_convenience | currency : "INR" : "symbol" : "1.2-2" }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">eSign Convenience:</span>
        <span class="summary-value">{{ paymentAmountData.esign_convenience | currency : "INR" : "symbol" : "1.2-2" }}</span>
      </div>
      <div *ngIf="paymentAmountData.cess > 0" class="summary-row">
        <span class="summary-label">Cess:</span>
        <span class="summary-value">{{ paymentAmountData.cess | currency : "INR" : "symbol" : "1.2-2" }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">GST:</span>
        <span class="summary-value">{{ paymentAmountData.tax | currency : "INR" : "symbol" : "1.2-2" }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">Handling Fee:</span>
        <span class="summary-value">{{ paymentAmountData.handling_fee | currency : "INR" : "symbol" : "1.2-2" }}</span>
      </div>
      <div class="summary-row total-row">
        <span class="summary-label">Total Amount:</span>
        <span class="summary-value">{{ paymentAmountData.total_amount | currency : "INR" : "symbol" : "1.2-2" }}</span>
      </div>
    </div>
    <div *ngIf="!paymentAmountData" class="loading-message">
      Loading payment details...
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Close</button>
  </div>
</ng-template>

<div class="toast_display_layer">
  <p-toast></p-toast>
</div>
